import { deleteCookie, getCookie, setCookie } from '@vfde-sails/utils';
import { Cookies } from '../enums/network';
import { Address } from '@vfde-sails/avc-core';

/**
 * Returns the address as an Address type object from cookie.
 * Returns undefined if the address cookie not found.
 * @throws {SyntaxError | InvalidCharacterError | URIError} - can't parse cookie
 * @throws {Error} - address cookie is not existing
 * @returns {Address}
 */
export const getAddressFromCookie = (): Address => {
    const addressCookie = getCookie(Cookies.ADDRESS);

    if (!addressCookie) {
        throw new Error('Address cookie not found');
    }

    return JSON.parse(atob(decodeURIComponent(addressCookie))) as Address;
};

/**
 * Checks if cookie is present by name
 */
export const isCookiePresent = (name: Cookies): boolean => !!getCookie(name);

/**
 * Sets 3P Cookie with an expiration of 1 day
 */
export const set3PCookie = () => setCookie(Cookies.THREE_P, { value: 'true', expires: 86400 });

/**
 * Remove gigakombi cookie
 */
export const removeGigakombiCookie = () => deleteCookie(Cookies.GIGAKOMBI);
